import React, { Component } from 'react'
import {NavLink} from 'react-router-dom'
import {UserNav, Field, Textarea, Load} from '../../../components'
import Router from '../../../services/Router'
import {ButtonRouter, TheftSoloStyle} from '../../../styles'
import {fetchPage} from './../../../services/ApiController'

export default class Theft extends Component {
  state = {
    fields: [],
    ready: false,
  }

  componentDidMount() {
    this.getData()
  }

  componentWillReceiveProps({data}) {
    if (data !== this.props.data) {
      // this.setState({
        
      // })
    }
  }

  getData = async () => {
    await fetchPage(`/alerts/theft/${this.props.match.params.slug}`).then((data) => {
      const fields = [
        {
          type: 'text',
          id: 'models',
          name: 'models',
          value: data.model,
          label: 'Models'
        },
        // {
        //   type: 'text',
        //   id: 'date',
        //   name: 'date',
        //   value: data.date,
        //   label: 'Date',
        // },
        // {
        //   type: 'text',
        //   id: 'reported_date',
        //   name: 'reported_date',
        //   value: data.reportedTo,
        //   label: 'Reported Date',
        // },
        {
          type: 'text',
          id: 'reference',
          name: 'reference',
          value: data.reference,
          label: 'Reference'
        },
        {
          type: 'text',
          id: 'description',
          name: 'description',
          value: data.description,
          label: 'Description'
        },
        {
          type: 'text',
          id: 'serial_number',
          name: 'serial_number',
          value: data.serialNumber,
          label: 'Serial Number'
        },
        {
          type: 'text',
          id: 'status',
          name: 'status',
          value: data.status,
          label: 'Status'
        },
        // {
        //   type: 'textarea',
        //   id: 'comments',
        //   name:'comments',
        //   value: data.details,
        //   label: 'Comments',
        // },
      ]
      this.setState({
        fields,
        ready: true
      })
    }).catch((e) => {
      console.log('Ooops something wrong with Question', e)
    })
  }

  render () {
    const { fields, ready } = this.state 
    return (
      <div className={`theft page-inner ${TheftSoloStyle}`}>
        <UserNav />
        <div className="thefts-nav">
          <ul className={`reset ${ButtonRouter} flex `}>
            <li>
              <NavLink to={Router.counterfeits.path} exact> <span>Counterfeits</span> </NavLink>
            </li>
            <li>
              <NavLink to={Router.thefts.path} > <span>Thefts</span> </NavLink>
            </li>
          </ul>
        </div>
        <div className="theft-form">
          {
            !ready && (
              <div className='content-loader'>
                <Load width={24} height={24} />
              </div>
            )
          }
          {
            fields.map((field, index) => (
              field.type === 'text' ? 
              <Field disabled {...field} key={index}> {field.label} </Field>
              : <Textarea disabled {...field} key={index}> {field.label} </Textarea>
            ))
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Theft.js